import MonitoringFilterFieldNames from '@lib/enums/fieldNames/monitoringFilterFieldNames';
import { MonitoringEntity, MonitoringType, StatusKind } from '../enums';

export default function getLegendFilterName(
  monitoringEntity: MonitoringEntity,
  monitoringType: MonitoringType,
  statusKind?: StatusKind,
) {
  if (monitoringType === MonitoringType.Anomaly && statusKind) {
    return `${monitoringEntity}-${monitoringType}-${statusKind}-${MonitoringFilterFieldNames.Legend}`;
  }
  return `${monitoringEntity}-${monitoringType}-${MonitoringFilterFieldNames.Legend}`;
}
